export default {
  showMore: {
    id: 'bo_sellers-orders-components-filters-show_more_filters',
    defaultMessage: 'Show more filters',
  },
  showLess: {
    id: 'bo_sellers-orders-components-filters-show_less_filters',
    defaultMessage: 'Show less filters',
  },
} as const
